var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-line-understanding',_vm._b({staticClass:"chart-line-understanding-relative",attrs:{"styles":_vm.relativeStyle}},'chart-line-understanding',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }